import React from 'react';
import { ListGroup } from '@/components/ui';

type SidebarItem = 'about' | 'trip-inspection-history' | 'preventative-maintenance' | 'vehicle-history' | 'vehicle-defects' | 'technical-settings' | 'vehicle-components' | 'blue-book-rates' | 'vehicle-attachments' | 'repair-history';

interface VehicleSidebarProps {
  activeSection: SidebarItem;
  onSectionChange: (section: SidebarItem) => void;
}

const VehicleSidebar: React.FC<VehicleSidebarProps> = ({ activeSection, onSectionChange }) => {
  const menuItems: { key: SidebarItem; label: string; icon?: string }[] = [
    { key: 'about', label: 'About', icon: 'bi-info-circle' },
    { key: 'trip-inspection-history', label: 'Trip Inspection History', icon: 'bi-clipboard-check' },
    { key: 'preventative-maintenance', label: 'Preventative Maintenance', icon: 'bi-tools' },
    { key: 'vehicle-history', label: 'Vehicle History', icon: 'bi-clock-history' },
    { key: 'vehicle-defects', label: 'Vehicle Defects', icon: 'bi-exclamation-triangle' },
    { key: 'vehicle-components', label: 'Vehicle Components', icon: 'bi-puzzle' },
    { key: 'blue-book-rates', label: 'Rates', icon: 'bi-cash-stack' },
    { key: 'vehicle-attachments', label: 'Vehicle Attachments', icon: 'bi-paperclip' },
    { key: 'repair-history', label: 'Repair History', icon: 'bi-wrench' },
    { key: 'technical-settings', label: 'Technical Settings', icon: 'bi-gear' }
  ];

  return (
    <ListGroup>
      {menuItems.map((item) => (
        <ListGroup.Item
          key={item.key}
          action
          active={activeSection === item.key}
          onClick={() => onSectionChange(item.key)}
        >
          {item.icon && <i className={`bi ${item.icon} tw-mr-2`}></i>}
          {item.label}
        </ListGroup.Item>
      ))}
    </ListGroup>
  );
};

export default VehicleSidebar;

